<script>
  import Root from "./bits/calendar.svelte";

  import Day from "./calendar-day.svelte";
  import Grid from "./calendar-grid.svelte";
  import GridBody from "./calendar-grid-body.svelte";
  import Cell from "./calendar-cell.svelte";
  import GridHead from "./calendar-grid-head.svelte";
  import HeadCell from "./calendar-head-cell.svelte";
  import GridRow from "./calendar-grid-row.svelte";
  import Header from "./calendar-header.svelte";
  import Heading from "./calendar-heading.svelte";
  import Months from "./calendar-months.svelte";
  import NextButton from "./calendar-next-button.svelte";
  import PrevButton from "./calendar-prev-button.svelte";
  import * as Calendar from "./index.js";
  import {cn} from "../../utils.js";
  import {progress} from "../../data/progress/feature.progress.svelte.js";
  import * as booking_select_datetime from "../../data/booking/booking.scenarios.select.datetime.svelte.js";
  import {widgets} from "../../data/widgets/feature.widgets.svelte.js";
  import {booking} from "../../data/booking/feature.booking.svelte.js";
  import { ENTRY_TYPE_OVERRULE_BADENKAART, ENTRY_TYPE_OVERRULE_BADENKAART_KORT } from '../../AppConstants.js';

  () => {
    typeof Calendar
  }
  () => {
    typeof CalendarPrimitive
  }

  let {
        ref           = $bindable(null),
        value         = $bindable(),
        placeholder   = $bindable(),
        class: className,
        weekdayFormat = "short",
        type          = "single",
        placement     = "reserveerstraat", // reserveerstraat/widget
        ...restProps
      } = $props();

  let bCalendarHasPrices = $state(false);
  // console.log('snel testje 1A', Object.keys(progress.aCalendarDates).length, booking.sSelectedEntryType, $state.snapshot(progress.aCalendarDates));
  if ( progress.aCalendarDates && Object.keys(progress.aCalendarDates).length > 0 && booking.sSelectedEntryType !== ENTRY_TYPE_OVERRULE_BADENKAART && booking.sSelectedEntryType !== ENTRY_TYPE_OVERRULE_BADENKAART_KORT )
  {
    let oDayConfig;
    // console.log('snel testje 1A ALOHA');
    for ( const sDateKey in progress.aCalendarDates )
    {
      oDayConfig = progress.aCalendarDates[sDateKey];

      // console.log('snel testje 1B', oDayConfig);
      for ( const key in oDayConfig )
      {
        // console.log('snel testje 1C', key);
        if ( key.startsWith('p_') && oDayConfig[key] > 0 )
        {
          bCalendarHasPrices = true;
          break;
        }
      }
    }
  }

</script>

<!--
Discriminated Unions + Destructing (required for bindable) do not
get along, so we shut typescript up by casting `value` to `never`.
-->

<Root
  bind:value
  bind:ref
  bind:placeholder
  {weekdayFormat}
  class={cn("p-3", className)}
  locale="nl"
  isDateUnavailable={(oDate) => {
    return false; // keuze.. of disabled of unavailble.. voor nu disabled
    // let sRequestedDate = oDate.year + '-' + oDate.month + '-' + oDate.day;
    //
    // if(typeof progress.aCalendarDates[sRequestedDate] === "undefined") {
    //   // we zitten buiten het bereik
    //   return true;
    // }
    //
    // let oCalendarConfigForDate = booking_select_datetime.getCalendarConfigForDate(sRequestedDate)
    //
    // return ! oCalendarConfigForDate.bIsEnabled;
  }}
  isDateDisabled={(oDate) => {
    //return false; // keuze.. of disabled of unavailble.. voor nu disabled
    let sRequestedDate = oDate.year + '-' + oDate.month + '-' + oDate.day;

    if(typeof progress.aCalendarDates[sRequestedDate] === "undefined") {
      // we zitten buiten het bereik
      return true;
    }

    let oCalendarConfigForDate = booking_select_datetime.getCalendarConfigForDate(sRequestedDate)

    if(!oCalendarConfigForDate) {
      return true;
    }

    return ! oCalendarConfigForDate.bIsEnabled;
  }}
  {...restProps}
>
  {#snippet children({months, weekdays})}
    <Header>
      <PrevButton/>
      <Heading/>
      <NextButton/>
    </Header>
    <Months>
      {#each months as month}
        <Grid>
          <GridHead>
            <GridRow class="flex justify-around align-center">
              {#each weekdays as weekday}
                <HeadCell>
                  {weekday.slice(0, 2).toUpperCase()}
                </HeadCell>
              {/each}
            </GridRow>
          </GridHead>
          <GridBody>
            {#each month.weeks as weekDates}
              <GridRow class="mt-2 w-full justify-between">
                {#each weekDates as date (date)}
                  {@const oCalendarDayConfig = booking_select_datetime.getCalendarConfigForDate(date)}
                  {#if widgets.bIsThisAWidgetBuildInsteadOfTheShop === true}
                    <!-- widget -->
                    <Cell {date} month={month.value} style="width: 13%;">
                      <Day
                        date={date}
                        selected_value={value}
                        oCalendarDayConfig={oCalendarDayConfig}
                        bCalendarHasPrices={bCalendarHasPrices}
                      />
                    </Cell>
                  {:else}
                    <!-- reserveerstraat -->
                    <Cell {date} month={month.value} style="width: 14.2%;">
                      <Day
                        date={date}
                        selected_value={value}
                        oCalendarDayConfig={oCalendarDayConfig}
                        bCalendarHasPrices={bCalendarHasPrices}
                      />
                    </Cell>
                  {/if}
                {/each}
              </GridRow>
            {/each}
          </GridBody>
        </Grid>
      {/each}
    </Months>
  {/snippet}
</Root>
